import { InputSwitch } from '@creditornot/cb-switch';
import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { useOfferOverridesContext } from '../../../context/OfferOverridesContext';
import { FormRowRenderer } from '../FormRowRenderer';
import { PreviewRowContainer } from '../OfferDetailsFormFields.styles';
import { FormValues } from '../types';

type Props = BaseField & { isSingleVenue: boolean };

export const LimitedQuantity = ({ sidePanelMode, isSingleVenue }: Props) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();
  const { values } = useFormState<FormValues>();
  const { maybeOverriddenOffer } = useOfferOverridesContext();
  const fieldNameToUse = isSingleVenue ? 'inventoryMode' : 'inventoryModeOverride';

  const previewComponent = (
    <PreviewRowContainer>
      <FormattedMessage
        id={
          maybeOverriddenOffer?.inventory_mode === 'limited_quantity'
            ? 'menu-item.enabled-true'
            : 'menu-item.enabled-false'
        }
      />
    </PreviewRowContainer>
  );

  const editComponent = (
    <Field name={fieldNameToUse}>
      {({ input }) => (
        <InputSwitch
          checked={values[fieldNameToUse] === 'limited_quantity'}
          onChange={event => {
            input.onChange(event.currentTarget.checked ? 'limited_quantity' : 'binary');
          }}
        />
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'limited-quantity.use' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      sidePanelMode={sidePanelMode}
      offer={maybeOverriddenOffer}
      isOnlyForVenueLevel
    />
  );
};
